// Recently OPENED shipments (successful outcomes only): recorded when a search
// result is selected or a shipment-details page is viewed. One merchant-namespaced
// key, LRU by order reference, capped small - this list feeds the omnisearch
// RECENT group and the "Try your AWB ..." typewriter hint.
const CAP = 6;

const storageKey = () => {
  const merchantId = localStorage.getItem("merchantId");
  return merchantId ? `wv_recent_shipments_${merchantId}` : null;
};

export function getRecentShipments() {
  try {
    const key = storageKey();
    if (!key) return [];
    const parsed = JSON.parse(localStorage.getItem(key) || "[]");
    // Cap on read too - the store is user-editable, never trust its size.
    return Array.isArray(parsed) ? parsed.filter((r) => r && r.ref).slice(0, CAP) : [];
  } catch {
    return [];
  }
}

export function pushRecentShipment({ ref, awb, code }) {
  try {
    const key = storageKey();
    if (!key || !ref) return;
    const rest = getRecentShipments().filter((r) => r.ref !== ref);
    const next = [{ ref: String(ref), awb: awb ? String(awb) : null, code: code != null ? String(code) : null, at: Date.now() }, ...rest].slice(0, CAP);
    localStorage.setItem(key, JSON.stringify(next));
  } catch {
    // Storage full/unavailable - history is a convenience, never an error.
  }
}

export function clearRecentShipments() {
  try {
    const key = storageKey();
    if (key) localStorage.removeItem(key);
  } catch {
    // ignore
  }
}
